const { createSlice } = require("@reduxjs/toolkit");

const billingSlice = createSlice({
  name: "billing",
  initialState: {
    billingList: [],
    currentPlan: null,
    actionableBillingId: null,
    isBillingCreateModalOpen: false,
    showDiscardModal: false,
    invoiceData: null,
    refetchBillingData: false,
    workspacePlan: null,
    checkPlanLimitation: null,
    billingDetails: null,
    isEditingBillingDetails: false,
    paymentMethodDetails: null,
    showSidebarMessage: false,
    showSidebarMessage2: false,
    sidebarCountData: null,
  },
  reducers: {
    toggleIsBillingCreateModalOpen: (state) => ({
      ...state,
      isBillingCreateModalOpen: !state.isBillingCreateModalOpen,
    }),
    toggleActionableBillingId: (state, action) => ({
      ...state,
      actionableBillingId: action.payload ?? null,
    }),
    toggleShowDiscardModal: (state) => ({ ...state, showDiscardModal: !state.showDiscardModal }),
    toggleShowSidebarMessage: (state) => ({
      ...state,
      showSidebarMessage: !state.showSidebarMessage,
    }),
    toggleShowSidebarMessage2: (state) => ({
      ...state,
      showSidebarMessage2: !state.showSidebarMessage2,
    }),
    setCurrentPlan: (state, action) => {
      return {
        ...state,
        currentPlan: action.payload ?? null,
      };
    },
    setInvoiceData: (state, { payload }) => ({
      ...state,
      invoiceData: payload,
    }),

    setRefetchBillingData: (state, { payload }) => {
      return { ...state, refetchBillingData: payload };
    },
    setWorkspacePlan: (state, { payload }) => ({
      ...state,
      workspacePlan: payload,
    }),
    setCheckPlanLimitation: (state, { payload }) => {
      return { ...state, checkPlanLimitation: payload };
    },
    setSidebarCountData: (state, { payload }) => {
      return { ...state, sidebarCountData: payload };
    },
    setBillingDetails: (state, { payload }) => ({
      ...state,
      billingDetails: payload,
    }),
    setPaymentMethodDetails: (state, { payload }) => ({
      ...state,
      paymentMethodDetails: payload,
    }),
    setIsEditingBillingDetails: (state, { payload }) => ({
      ...state,
      isEditingBillingDetails: payload,
    }),
  },
});

export const {
  toggleIsBillingCreateModalOpen,
  toggleActionableBillingId,
  toggleShowDiscardModal,
  setCurrentPlan,
  setInvoiceData,
  setRefetchBillingData,
  setWorkspacePlan,
  setCheckPlanLimitation,
  setBillingDetails,
  setIsEditingBillingDetails,
  setPaymentMethodDetails,
  toggleShowSidebarMessage,
  toggleShowSidebarMessage2,
  setSidebarCountData,
} = billingSlice.actions;

export default billingSlice.reducer;
